module.exports = __webpack_public_path__ + "static/img/20.81a9241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/20.jpg
// module id = roLI
// module chunks = 16